import type { PaginationCriteria, SortCriteria } from '@openx/types/tableCriteria.ts';

export const isSortCriteria = (criteria: SortCriteria | PaginationCriteria): criteria is SortCriteria =>
  (criteria as SortCriteria).column !== undefined || (criteria as SortCriteria).direction !== undefined;
